//#region src/infrastructure/environment-type.ts
var EnvironmentType = /* @__PURE__ */ function(EnvironmentType) {
	EnvironmentType["DEV"] = "DEV";
	EnvironmentType["QA"] = "QA";
	EnvironmentType["PROD"] = "PROD";
	return EnvironmentType;
}({});
//#endregion
export { EnvironmentType };

//# sourceMappingURL=environment-type.js.map